export default __webpack_public_path__ + "images/17875f3dc88284a002f9da0f73fd8d5d.svg";